export default {
  apiKey: "AIzaSyDpRfwmOFha81NGIzN6cMryJbvkqO5qk8U",
  authDomain: "conociendo-a-loly-vcorta-e6245.firebaseapp.com",
  databaseURL: "https://conociendo-a-loly-vcorta-e6245.firebaseio.com",
  projectId: "conociendo-a-loly-vcorta-e6245",
  storageBucket: "conociendo-a-loly-vcorta-e6245.appspot.com",
  messagingSenderId: "240178631297",
  appId: "1:240178631297:web:22d3cd3d09fcd59c247380",
  measurementId: "G-RSWEVVGEP4",
};
